var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { AssessmentGroup } from '../../shared/models/assessment-group';
import { AssessmentGroupService } from '../../shared/services/assessment-group.service';
import { AssessmentTokenService } from '../../shared/services/assessment-token.service';
import { AlertService } from '../../shared/services/alert.service';
var AssessmentGroupDisplay = /** @class */ (function (_super) {
    __extends(AssessmentGroupDisplay, _super);
    function AssessmentGroupDisplay() {
        var _this = _super.call(this) || this;
        _this.ShowAdd = false;
        _this.Show = false;
        return _this;
    }
    return AssessmentGroupDisplay;
}(AssessmentGroup));
var AssessmentGroupEditComponent = /** @class */ (function () {
    function AssessmentGroupEditComponent(assessmentGroupService, assessmentTokenService, alertService) {
        this.assessmentGroupService = assessmentGroupService;
        this.assessmentTokenService = assessmentTokenService;
        this.alertService = alertService;
        this.showAdd = false;
        this.groups = [];
        this.showGroups = false;
    }
    AssessmentGroupEditComponent.prototype.ngOnInit = function () {
        this.loadGroups();
    };
    AssessmentGroupEditComponent.prototype.loadGroups = function () {
        var _this = this;
        this.hasLoaded = false;
        var showAllGroups = this.showGroups;
        Promise.all([this.assessmentTokenService.loadAssessmentTokens(), this.assessmentGroupService.getAssessmentGroups(showAllGroups)])
            .then(function (results) {
            _this.hasLoaded = true;
            var groups = results[1];
            // add a display property so we can expand/contract it.
            _this.groups = groups.map(function (g) {
                var displayGroup = new AssessmentGroupDisplay();
                Object.assign(displayGroup, g);
                displayGroup.Show = false;
                return displayGroup;
            });
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error("Check your internet connection.  Failed to load data");
        });
    };
    AssessmentGroupEditComponent.prototype.reloadGroups = function (event) {
        this.showGroups = !this.showGroups;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.loadGroups();
    };
    AssessmentGroupEditComponent.prototype.getTokensRemaining = function (group) {
        if (!group) {
            return 0;
        }
        return this.assessmentTokenService.getGroupRemainingTokens(group);
    };
    AssessmentGroupEditComponent.prototype.toggleGroup = function (group) {
        group.Show = !group.Show;
        console.log(group, group.Show);
    };
    AssessmentGroupEditComponent.prototype.updateAssessmentVersions = function (group, event) {
        var _this = this;
        event.stopImmediatePropagation();
        var info = this.alertService.info("Updating assessment versions", 30000);
        this.assessmentGroupService.updateAssessmentsForGroup(group)
            .then(function (updatedGroup) {
            _this.alertService.clearAlert(info);
            var index = _this.groups.findIndex(function (g) { return g == group; });
            var displayGroup = new AssessmentGroupDisplay();
            Object.assign(displayGroup, updatedGroup);
            displayGroup.Show = group.Show;
            _this.groups[index] = displayGroup;
            _this.alertService.success("Assessment versions updated");
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.clearAlert(info);
            _this.alertService.error("There was an error in updating the assessments for this group.  Check the server logs");
        });
    };
    AssessmentGroupEditComponent.prototype.addAssessmentToGroup = function (group, assessment) {
        var dup = group.Assessments.find(function (a) { return a.uid == assessment.uid; });
        if (dup) {
            alert("This assessment already has been added.");
            return;
        }
        group.Assessments.push(assessment);
        this.assessmentGroupService.addAssessmentToGroup(group, assessment).then(function (assessment) {
            assessment.version = assessment.version;
            assessment.id = assessment.id;
        })
            .catch(function (error) {
            console.error(error);
            // TODO: stephen need to display an error here...
            // remove it
            var index = group.Assessments.indexOf(assessment);
            if (index >= 0) {
                group.Assessments.splice(index, 1);
            }
        });
    };
    AssessmentGroupEditComponent.prototype.addGroupFromKeypress = function (event) {
        // enter key is 13
        if (!event || event.charCode !== 13) {
            return;
        }
        this.addGroup();
    };
    AssessmentGroupEditComponent.prototype.addGroup = function () {
        var _this = this;
        this.assessmentGroupService.createNewGroup(this.NewGroupName).then(function (group) {
            var display = new AssessmentGroupDisplay();
            Object.assign(display, group);
            // hide all the others, and show the one we just added.
            _this.groups.forEach(function (g) { return g.Show = false; });
            display.Show = true;
            display.ShowAdd = true;
            _this.NewGroupName = "";
            _this.groups.push(display);
        });
    };
    Object.defineProperty(AssessmentGroupEditComponent.prototype, "Groups", {
        get: function () {
            return this.groups;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentGroupEditComponent.prototype.toggleShowAdd = function (group, event) {
        event.stopImmediatePropagation();
        group.ShowAdd = !group.ShowAdd;
    };
    return AssessmentGroupEditComponent;
}());
export { AssessmentGroupEditComponent };



// WEBPACK FOOTER //
// ./src/app/admin/assessment-group-edit/assessment-group-edit.component.ts.pre-build-optimizer.js